// extracted by css-extract-rspack-plugin
export default {"banner":"banner--FQcxyXGDhIE0gIic"};